export const ACTION_TYPES_BY_PLATFORM = {
    pluglead: [
        { value: 'webhook_call', label: 'Chamada de Webhook para PlugLead' },
    ],
    manual: [
        { value: 'webhook_call', label: 'Chamada de Webhook' },
    ],
    activecampaign: [
        { value: 'tag_add', label: 'Adicionar tag ao contato' },
        { value: 'list_add', label: 'Adicionar contato à lista' },
    ],
};

export const DEFAULT_ACTIONS_BY_PLATFORM = {
    pluglead: [{ type: 'webhook_call', config: { webhook_url: '' } }],
    manual: [],
    activecampaign: [],
};

export function getDefaultConfigForType(type) {
    switch (type) {
        case 'tag_add': return { tag_id: '', tag_name: '' };
        case 'list_add': return { list_id: '' };
        default: return { webhook_url: '' };
    }
}

export function generateDescription(event, planId, platform, community) {
    const triggers = {
        'payments.confirmed': 'um pagamento for confirmado',
        'payments.pix_generated': 'um Pix for gerado',
        'payments.checkout_dropped': 'um checkout for abandonado',
    };
    const destinations = {
        pluglead: 'PlugLead',
        manual: 'um endpoint externo via webhook',
        activecampaign: 'ActiveCampaign',
    };

    if (!event || !platform) return null;

    const plan = community?.plans?.find(p => String(p.id) === String(planId));
    const planLabel = plan ? `no plano "${plan.label}"` : 'em qualquer plano';
    const trigger = triggers[event] || event;
    const dest = destinations[platform] || platform;

    return `Quando ${trigger} ${planLabel}, o Ginastee irá enviar os dados do comprador para ${dest}.`;
}

let _keyCounter = 0;
export function newActionKey() {
    return `ak_${++_keyCounter}_${Date.now()}`;
}
